<template>
  <el-row class="teach-count">
    <el-col>
      <div class="activity-header flex-align-center mb-3">
        <div class="header-item">
          <el-button
            type="out-line"
            class="return-btn"
            icon="el-icon-arrow-left"
            size="small"
            @click="goBack"
          ></el-button>
        </div>
        <div class="flex-column header-item">
          <div class="activity-title">{{ activityData.title }}活动参与情况</div>
          <div class="activity-condition">活动完成条件：{{ activityData.finish_setting }}</div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <div class="flex-between flex-align-center">
            <div class="flex">
              <el-button type="primary" size="" @click="exportTable">导出表格</el-button>
              <!-- <el-button type="primary" size="" @click="messageDialogVisible = true">
                消息提醒
              </el-button> -->
            </div>

            <div class="data-range">统计范围：{{ countArea }}</div>
          </div>
        </div>
      </div>
      <div class="flex-between mb-3">
        <div>
          <el-select
            v-if="filterDimension == 1"
            class="group-condition"
            v-model="group"
            @change="handleGroup"
          >
            <el-option value="0" label="全部小组"></el-option>
            <el-option
              v-for="item in groupOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-if="filterDimension == 2"
            class="group-condition"
            v-model="course"
            @change="handleCourse"
          >
            <el-option value="0" label="全部选课"></el-option>
            <el-option
              v-for="item in courseOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="flex">
          <el-input v-model="keyword" placeholder="搜索关键字" @change="handleKeyword"></el-input>
          <el-button class="search-btn" type="primary" @click="handleKeyword">
            <i class="mdi mdi-magnify"></i>
          </el-button>
        </div>
      </div>
      <el-row>
        <el-col>
          <el-table
            id="course-activity-table"
            class="mb-3"
            :data="teachData"
            row-key="id"
            default-expand-all
            stripe=""
          >
            <el-table-column prop="username" label="学号"></el-table-column>
            <el-table-column prop="firstname" label="姓名"></el-table-column>
            <el-table-column
              width="300"
              prop="studySituation"
              label="学习情况"
              sortable
            ></el-table-column>
            <el-table-column prop="access_num" label="访问次数" sortable></el-table-column>
            <el-table-column prop="finish_status" label="活动完成情况" sortable>
              <template slot-scope="scope">
                <span v-if="scope.row.finish_status === 0" class="green-text">未完成</span>
                <span v-else-if="scope.row.finish_status === 1" class="red-text">已完成</span>
              </template>
            </el-table-column>
            <el-table-column prop="score" label="得分"></el-table-column>
            <el-table-column prop="last_access_time" label="最后学习时间"></el-table-column>
            <el-table-column width="200" label="操作">
              <template slot-scope="scope">
                <span v-if="scope.row.finish_status === 0">/</span>
                <!-- <span
                  class="operative"
                  v-if="scope.row.finish_status === 0"
                  @click="set(scope.row, 'complete')"
                >
                  强制完成
                </span>
                <span
                  class="operative red-text"
                  v-if="scope.row.finish_status === 1"
                  @click="set(scope.row, 'cancel')"
                >
                  取消完成
                </span> -->
                <!-- <span class="operative red-text" @click="set(scope.row, 'recalculate')">
                  重新统计
                </span> -->
              </template>
            </el-table-column>
          </el-table>
          <Pagination
            :totalSize="totalSize"
            :currentPage="currentPage"
            @setPageSizesVal="getPageSizesVal"
            @setCurPageVal="getCurPageVal"
          ></Pagination>
        </el-col>
      </el-row>
      <el-dialog :title="completeDialogTitle" :visible.sync="completeDialogVisible" width="20%">
        <div v-html="completeDialogContent"></div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="completeDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleOperate">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        class="message-dialog"
        :title="messageDialogTitle"
        :visible.sync="messageDialogVisible"
        width="30%"
      >
        <div class="message-item">
          <div class="item-title">对象类型</div>
          <div class="item-content">
            <el-radio-group v-model="messageObjectType">
              <el-radio :label="1">按完成情况</el-radio>
              <el-radio :label="2">按小组</el-radio>
              <el-radio :label="3">按学生</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="message-item">
          <div class="item-title">发送对象</div>
          <div class="item-content">
            <el-select class="" v-model="messageObject">
              <el-option
                v-for="item in messageObjectOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="message-item">
          <div class="item-title">消息内容</div>
          <div class="item-content">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入消息内容"
              v-model="messageContent"
            ></el-input>
          </div>
        </div>
        <div class="message-item">
          <div class="item-title">发送时间</div>
          <div class="item-content">
            <el-radio-group v-model="sendTime">
              <el-radio :label="1">立即发送</el-radio>
            </el-radio-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="messageDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="sendMessage">确 定</el-button>
        </span>
      </el-dialog>
    </el-col>
  </el-row>
</template>
<script>
import Pagination from '@/components/Pagination.vue'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      // 教学统计活动操作
      completeDialogTitle: '提示',
      completeDialogContent: '是否强制完成',
      completeDialogVisible: false,
      // 教学统计消息提醒
      messageDialogTitle: '活动名的消息提醒',
      messageDialogVisible: false,
      messageObjectType: '',
      messageObject: '',
      messageObjectOption: [
        { id: 1, name: '已完成' },
        { id: 2, name: '未完成' },
        { id: 3, name: '全部' },
      ],
      messageContent: '',
      sendTime: '',
      // 教学统计
      // 教学统计活动详情
      activityData: {
        start_time: '',
        end_time: '',
      },
      teachData: [],
      // 小组选项
      group: '0',
      groupOption: [],
      // 选课选项
      course: '0',
      courseOption: [],
      // 点击不同操作按钮对应弹出的对话框类型
      operateType: '',
      // 搜索关键字
      keyword: '',
      // 页码数据
      totalSize: null,
      currentPage: 1,
      pageSizesVal: 10,
    }
  },
  computed: {
    // 统计范围
    countArea() {
      return (
        this.$store.state.course.courseInfo.statistics_start_time.split('-').join('.') +
        '-' +
        this.$store.state.course.courseInfo.statistics_end_time.split('-').join('.')
      )
    },
    // 筛选维度
    filterDimension() {
      return this.$store.state.course.courseInfo.search_setting
    },
  },
  mounted() {
    this.getActDetailApi()
    this.getActStudentApi()
    this.getCourseGroupApi()
    this.getCourseJoinTypeApi()
  },
  methods: {
    // 获取课程小组接口
    async getCourseGroupApi() {
      await this.$store
        .dispatch('course/getCourseGroup', {
          course_id: +this.$route.query.courseId,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.groupOption = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取选课方式接口
    async getCourseJoinTypeApi() {
      await this.$store
        .dispatch('course/getCourseJoinType', {
          course_id: +this.$route.query.courseId,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.courseOption = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取课程活动详情接口
    async getActDetailApi() {
      await this.$store
        .dispatch('course/getActDetail', {
          course_id: Number(this.$route.query.courseId),
          cm_id: Number(this.$route.query.activityId),
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.activityData = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取课程活动学生详情接口
    async getActStudentApi() {
      await this.$store
        .dispatch('course/getActStudent', {
          course_id: Number(this.$route.query.courseId),
          cm_id: Number(this.$route.query.activityId),
          group: Number(this.group) || 0,
          method: this.course || 0,
          keyword: this.keyword || '',
          page: this.currentPage,
          pagesize: this.pageSizesVal,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.teachData = res.data.list.map(item => {
              let studySituation = ''
              for (let key in item.situation) {
                if (item.situation[key]) {
                  switch (key) {
                    case 'numfiles':
                      studySituation === ''
                        ? (studySituation += `作业附件数${item.situation[key]}`)
                        : (studySituation += `，作业附件数${item.situation[key]}`)
                      break
                    case 'submit_num':
                      studySituation === ''
                        ? (studySituation += `提交测验${item.situation[key]}次`)
                        : (studySituation += `，提交测验${item.situation[key]}次`)
                      break
                    case 'discussion':
                      studySituation === ''
                        ? (studySituation += `主题数${item.situation[key]}`)
                        : (studySituation += `，主题数${item.situation[key]}`)
                      break
                    case 'post':
                      studySituation === ''
                        ? (studySituation += `回帖数${item.situation[key]}`)
                        : (studySituation += `，回帖数${item.situation[key]}`)
                      break
                    case 'viewtime':
                      if (item.situation[key] >= 60) {
                        studySituation === ''
                          ? (studySituation += `视频查看时长${(item.situation[key] / 60).toFixed(
                              0
                            )}min`)
                          : (studySituation += `，视频查看时长${(item.situation[key] / 60).toFixed(
                              0
                            )}min`)
                      } else if (item.situation[key] >= 0) {
                        studySituation === ''
                          ? (studySituation += `视频查看时长${item.situation[key]}s`)
                          : (studySituation += `，视频查看时长${item.situation[key]}s`)
                      }

                      break
                    case 'spend_time':
                      if (item.situation[key] >= 60) {
                        studySituation === ''
                          ? (studySituation += `学习时长${(item.situation[key] / 60).toFixed(
                              0
                            )}min`)
                          : (studySituation += `，学习时长${(item.situation[key] / 60).toFixed(
                              0
                            )}min`)
                      } else if (item.situation[key] >= 0) {
                        studySituation === ''
                          ? (studySituation += `学习时长${item.situation[key]}s`)
                          : (studySituation += `，学习时长${item.situation[key]}s`)
                      }
                      break
                  }
                }
              }
              return {
                studySituation: studySituation,
                ...item,
              }
            })
            this.totalSize = res.data.paging.records
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    goBack() {
      this.$router.go(-1)
    },
    // 筛选处理事件
    handleGroup(value) {
      console.log('value:', value)
      this.getActStudentApi()
    },
    handleCourse(value) {
      console.log('value:', value)
      this.getActStudentApi()
    },
    handleKeyword(value) {
      console.log('value:', value)
      this.getActStudentApi()
    },
    set(value, type) {
      console.log(value)
      if (type === 'complete') {
        this.operateType = 'complete'
        this.completeDialogTitle = '提示'
        this.completeDialogContent = '是否强制完成'
      } else if (type === 'cancel') {
        this.operateType = 'cancel'
        this.completeDialogTitle = '提示'
        this.completeDialogContent = '是否取消完成'
      } else if (type === 'recalculate') {
        this.operateType = 'recalculate'
        this.completeDialogTitle = '重新统计完成'
        this.completeDialogContent = `
          <div>是否重新统计完成？</div>
          <div>目前已有的活动完成情况将被覆盖,</div>
          <div>且无法恢复</div>
        `
      }
      this.completeDialogVisible = true
    },
    handleOperate() {
      if (this.operateType === 'complete') {
        console.log('强制完成')
      } else if (this.operateType === 'cancel') {
        console.log('取消完成')
      } else if (this.operateType === 'recalculate') {
        console.log('重新统计')
      }
      this.completeDialogVisible = false
    },
    sendMessage() {
      console.log('发送消息提醒')
      this.messageDialogVisible = false
    },
    // 页码操作
    getPageSizesVal(pageSizesVal) {
      this.pageSizesVal = pageSizesVal
      this.getActStudentApi()
    },
    getCurPageVal(curPageVal) {
      this.currentPage = curPageVal
      this.getActStudentApi()
    },
    // 导出表格
    exportTable() {
      //导出名称
      let excelName = '教学统计' + new Date().getTime() + '.xlsx'
      const xlsxParam = { raw: true } //转化成Excel使用原始格式
      const table_book = this.$XLSX.utils.table_to_book(
        document.querySelector('#course-activity-table'),
        xlsxParam
      )
      const table_write = this.$XLSX.write(table_book, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      })
      try {
        this.$FileSaver.saveAs(
          new Blob([table_write], { type: 'application/octet-stream' }),
          excelName
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, table_write)
      }
      return table_write
    },
  },
}
</script>
<style lang="scss" scoped>
.data-range {
  font-size: 14px;
  color: #6c757d;
  line-height: 19px;
}
.teach-count {
  ::v-deep .el-table {
    thead {
      th.el-table__cell {
        background-color: #f5f7fa;
      }
    }
    .cell {
      color: #6c757d;
    }
  }
  .activity-header {
    .header-item {
      margin-right: 24px;
      .return-btn {
        color: rgba(50, 148, 246, 1);
        border-color: rgba(50, 148, 246, 1);
      }
      .activity-title {
        font-size: 16px;
        font-weight: bold;
        color: #343a40;
      }
      .activity-condition {
        font-size: 14px;
        color: #98a6ad;
      }
    }
  }
  .group-condition {
    margin-right: 12px;
  }
}
.message-dialog {
  .message-item {
    font-size: 14px;
    color: #6c757d;
    margin-bottom: 24px;
    .item-title {
      margin-bottom: 8px;
    }
    .item-content {
    }
  }
}
.mdi.mdi-magnify {
  font-size: 22px;
  line-height: 18px;
}
.search-btn.el-button.el-button--primary {
  width: 56px;
  height: 40px;
  padding: 11px;
  border-radius: 3px;
}
</style>
